const DotIcon = ({ ...props }) => {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <circle cx="12" cy="12" r="4"/>
    </svg>
  );
};

export default DotIcon;
